// extracted by mini-css-extract-plugin
export default {"nav":"nav__1PQyn"};
    if(module.hot) {
      // 1788784386764
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  